module.exports = __webpack_public_path__ + "static/media/timely_project_completion.4ad2a6dd.svg";